export default "__VITE_ASSET__CkwZTHf___"